import { autoserializeAs, autoserialize, Serialize, Deserialize } from 'cerialize';
import { Notification } from "./notification";
import { ProviderFeeSchedule } from './provider-fee-schedule';
import { ClientFeeSchedule } from './client-fee-schedule';
import { ApprovalTypeConstants, isNullOrUndefined } from '@uzurv/core';

export class NotificationInfo {
  @autoserializeAs(Notification)
  notification: Notification;

  @autoserialize
	message: string;

  notificationObject: ClientFeeSchedule | ProviderFeeSchedule;

  @autoserialize
  notificationObjectType: string;

  static OnSerialized(instance: NotificationInfo, json: any): void {

    if (!isNullOrUndefined(instance.notificationObjectType)) {
      switch (instance.notificationObjectType) {
        case ApprovalTypeConstants.CLIENT_FEE_SCHEDULE:
          json.notificationObject = Serialize(instance.notificationObject, ClientFeeSchedule);
          break;
        case ApprovalTypeConstants.PROVIDER_FEE_SCHEDULE:
          json.notificationObject = Serialize(instance.notificationObject, ProviderFeeSchedule);
          break;
        default:
          break;
      }
    }
  }

  static OnDeserialized(instance: NotificationInfo, json: any): void {

    if (!isNullOrUndefined(json['notificationObjectType'])) {
      switch (instance.notificationObjectType) {
        case ApprovalTypeConstants.CLIENT_FEE_SCHEDULE:
          instance.notificationObject = Deserialize(json['notificationObject'], ClientFeeSchedule);
          break;
        case ApprovalTypeConstants.PROVIDER_FEE_SCHEDULE:
          instance.notificationObject = Deserialize(json['notificationObject'], ProviderFeeSchedule);
          break;
        default:
          break;
      }
    }
  }
}
